import initStore from './initStore';
import actions from './actions';
import thunks from './thunks';

import { ICarePlanGoalsModel } from './types';

const carePlanGoals: ICarePlanGoalsModel = {
  ...initStore,
  ...actions,
  ...thunks,
};

export default carePlanGoals;
